import React, { useState } from 'react';
import {
  FaTachometerAlt,
  FaFileAlt,
  FaCalendarAlt,
  FaReceipt,
  FaUsers,
  FaConciergeBell,
} from 'react-icons/fa';

const sections = [
  {
    label: 'Dashboard',
    icon: <FaTachometerAlt />,
    questions: [
      'Show my dashboard overview',
      'What is my total revenue and profit?',
      'How many active events do I have?',
      'What is my outstanding vs collected amount?',
    ],
  },
  {
    label: 'Quotations',
    icon: <FaFileAlt />,
    questions: [
      'How many quotations do I have?',
      'How many quotations are approved and their value?',
      'What is the total value of rejected quotations?',
      'Show pending quotations count and amount',
    ],
  },
  {
    label: 'Events',
    icon: <FaCalendarAlt />,
    questions: [
      'How many total events do I have?',
      'How many events are completed?',
      'How many events are scheduled or in-progress?',
      'Show my cancelled events count',
    ],
  },
  {
    label: 'Bills',
    icon: <FaReceipt />,
    questions: [
      'How many invoices do I have?',
      'What is my total billing amount?',
      'How much payment is still pending?',
      'How much have clients paid in total?',
    ],
  },
  {
    label: 'Team & Payment',
    icon: <FaUsers />,
    questions: [
      'How many team members do I have?',
      'What is the total payment to my team?',
      'Show each member\'s payment details',
      'How much payment is pending for team?',
    ],
  },
  {
    label: 'Services',
    icon: <FaConciergeBell />,
    questions: [
      'How many services do I offer?',
      'What is the total value of all services?',
      'How many service categories do I have?',
      'Show my service catalog stats',
    ],
  },
];

const SuggestedQuestions = ({ onSelect }) => {
  const [activeSection, setActiveSection] = useState(0);

  return (
    <div className="ai-suggested">
      <div className="ai-suggested__tabs">
        {sections.map((sec, i) => (
          <button
            key={i}
            className={`ai-suggested__tab ${i === activeSection ? 'ai-suggested__tab--active' : ''}`}
            onClick={() => setActiveSection(i)}
            title={sec.label}
          >
            {sec.icon}
          </button>
        ))}
      </div>
      <div className="ai-suggested__section-label">{sections[activeSection].label}</div>
      <div className="ai-suggested__questions">
        {sections[activeSection].questions.map((q, i) => (
          <button
            key={i}
            className="ai-suggested__question"
            onClick={() => onSelect && onSelect(q)}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions;
